import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/sections/Nav";
import { Hero } from "@/components/sections/Hero";
import { WhoWeAre } from "@/components/sections/About";
import { WhyMicrodramas } from "@/components/sections/WhyMobile";
import { Traction } from "@/components/sections/Traction";
import { PlatformLogos } from "@/components/sections/PlatformLogos";
import { Originals } from "@/components/sections/OriginalIP";
import { Approach } from "@/components/sections/TechPhilosophy";
import { Partners } from "@/components/sections/Partners";
import { AboutOoru } from "@/components/sections/Team";
import { FinalCTA } from "@/components/sections/FinalCTA";
import { Footer } from "@/components/sections/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (!id || id === "#") return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  const goToContact = () => {
    const el = document.querySelector("#contact");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App bg-[#050505] text-white">
      <div className="grain-overlay" aria-hidden />
      <Nav onContact={goToContact} />
      <main>
        <Hero onContact={goToContact} />
        <WhoWeAre />
        <WhyMicrodramas />
        <Traction />
        <PlatformLogos />
        <Originals />
        <Approach />
        <Partners onContact={goToContact} />
        <AboutOoru />
        <FinalCTA />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}

export default App;
